import { defineComponent as _defineComponent } from 'vue';
import { ChevronRightIcon } from 'lucide-vue-next';
import { reactiveOmit } from '@vueuse/core';
import { PaginationNext, useForwardProps } from 'reka-ui';
import { cn } from 'Components/primitives/utils';
import { buttonVariants } from 'Components/primitives/button';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginationNext',
    props: {
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        size: { type: null, required: false, default: 'default' },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const delegatedProps = reactiveOmit(props, 'class', 'size');
        const forwarded = useForwardProps(delegatedProps);
        const __returned__ = { props, delegatedProps, forwarded, get ChevronRightIcon() { return ChevronRightIcon; }, get PaginationNext() { return PaginationNext; }, get cn() { return cn; }, get buttonVariants() { return buttonVariants; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
